// extracted by mini-css-extract-plugin
module.exports = {"root":"SelectPayment_root__h8Ouy","text":"SelectPayment_text__8jS0E","title":"SelectPayment_title__1Ipb9","btn":"SelectPayment_btn__JxkQ4"};